const gift = {
    isOpen: is_open_gift,
    thresholdPrice: $('#gift_thresholdPrice').attr('data-base-amount') / 100,
    // thresholdPrice: $('#gift_thresholdPrice').text(),
    giftId: 44240347234454,
    count: 1
}
gift.init = function () {
    if (!this.isOpen) {
        return false
    }

    this.checkGiftIsInCart().then(res => {
        this.checkCart(res)
    })

    $(document).on('click', '.pe-7s-close.gift', function () {
        $('#sp_notices_wrapper').remove()
    })
}

gift.checkGiftIsInCart = function () {
    return new Promise(resolve => {
        $.ajax({
            type: 'GET',
            url: `/cart.js`,
            dataType: "json",
            success: function (data) {
                resolve(data)
            },
            error: function (XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest.responseJSON.description);
            }
        });
    })
}

gift.checkCart = function (data) {
    return new Promise(resolve => {
        let isInCart = false
        let total_price = data.total_price;
      const thresholdPrice=$('#gift_thresholdPrice').attr('data-base-amount') / 100
        for (let i = 0; i < data.items.length; i++) {
            const item_id = data.items[i].variant_id;
            if (item_id == this.giftId) {
                isInCart = true;
                this.count = data.items[i].quantity;
                total_price -= data.items[i].final_price
            }
        }
        if (total_price / 100 >= thresholdPrice) {
            console.log('达到赠送标准');
            if (!isInCart) {
                console.log('不在购物车中，需要添加');
                this.addToCart(this.giftId).then(data => {
                    console.log('赠品加入购物车成功');
                    this.onCartUpdate()
                })
            } else {
                console.log('已在购物车中，不需要再添加');
            }
        } else {
            console.log('未达到赠送标准');
            this.removeToCart(this.giftId).then(res => {
                this.onCartUpdate()
            })
        }
        resolve()
    });
}

gift.addToCart = function (variantId) {
    return new Promise(resolve => {
        $.ajax({
            type: 'post',
            url: `/cart/add.js?id=${variantId}`,
            dataType: "json",
            success: function (data) {
                // console.log('~~~~~~执行完毕')
                localStorage.setItem('isAddGift', 'isAddGift')
                resolve()
            },
            error: function (XMLHttpRequest, textStatus) {
                $("body").append(`
              <div id="sp_notices_wrapper">
                <p class="shopify-info sp_notice show_notice">
                  <i class="facl facl-attention"></i>
                  Error: ${XMLHttpRequest.responseJSON.description}
                  <i class="pegk pe-7s-close gift"></i>
                </p>  
              </div>`)
                $('.add_js_cart').removeClass('loading')
                console.log(XMLHttpRequest.responseJSON.description);
            }
        });
    })
}

gift.removeToCart = function (variantId) {
    return new Promise(resolve => {
        if (!localStorage.getItem('isAddGift')) {
            return false
        }
        $.ajax({
            type: 'post',
            url: `/cart/change.js?id=${variantId}&quantity=${this.count - 1}`,
            dataType: "json",
            success: function (data) {
                // console.log('~~~~~~删除完毕')
                localStorage.removeItem('isAddGift')
                resolve()
            },
            error: function (XMLHttpRequest, textStatus) {
                $("body").append(`
              <div id="sp_notices_wrapper">
                <p class="shopify-info sp_notice show_notice">
                  <i class="facl facl-attention"></i>
                  Error: ${XMLHttpRequest.responseJSON.description}
                  <i class="pegk pe-7s-close gift"></i>
                </p>  
              </div>`)
                $('.add_js_cart').removeClass('loading')
                console.log(XMLHttpRequest.responseJSON.description);
            }
        });
    })
}

gift.onCartUpdate = function (bl, blUp_items, id) {
    if ($('body').hasClass('template-cart')) {
        if ($('.reload_cart_js').length > 0) {
            location.reload();
            return false;
        }

        fetch('/cart?view=pagejs', {
            "credentials": "same-origin",
            "headers": {
                "cache-control": "no-cache"
            }
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                data = data.split('[split_t4nt0]')[1];
                var arrCat = data.split("[split_t4nt]"),
                    OldCartCount = $('.jsccount').first().html(),
                    CurrentCartCount = arrCat[0];

                if (CurrentCartCount != OldCartCount) {
                    $('body').removeClass('t4_cart_count_' + OldCartCount).addClass('t4_cart_count_' + CurrentCartCount);
                    if (parseInt(CurrentCartCount) == 0) {
                        $('.nt_js_cart, .js_cart_cd').hide();
                        $('.shipping_calc_page').addClass('dn');
                        $('.empty_cart_page').show();
                    } else {
                        $('.empty_cart_page').hide();
                        $('.nt_js_cart, .js_cart_cd').show();
                        $('.shipping_calc_page').removeClass('dn');
                    }

                    $('.jsccount').html(CurrentCartCount)
                    var aar1 = arrCat[1].split(',]'),
                        this_thres = $('.cart_thres_' + aar1[0]);
                    if (aar1 != 'spt4') {

                        if (this_thres.is(":hidden")) {
                            $('.cart_thres_1,.cart_thres_2,.cart_thres_3').slideUp(200);
                            this_thres.slideDown(250);
                        }
                        if (CurrentCartCount != 0 && $('.cart_thres_3').is(":hidden")) {
                            ck_canvas = true;
                        } else {
                            ck_canvas = false
                        }
                        // UpdateShipBar(arrCat[1],aar1[1],this_thres);
                    }
                    if (blUp_items) { $('.js_cat_items').html(arrCat[2]); }
                    $('.js_cat_dics').html(arrCat[3]);
                    $('.js_cat_ttprice').html(arrCat[4]);
                    var savedMoney = parseInt($(".js_cat_ttprice .saved_price_box").first().attr('data-price'), 10) || 0;
                    $('.mini_cart_footer .saved').attr('data-savedmoney', savedMoney);
                    $('.js_cat_ttsavedprice').closest('.saved').attr('data-savedmoney', savedMoney);
                    if (savedMoney > 0) {
                        $('.js_cat_ttsavedprice').html('<div class="cart_tot_price">-' + geckoShopify.formatMoney(savedMoney) + '</div>');
                        $('.js_cat_ttsavedprice').closest('.saved').show();
                    } else {
                        $('.js_cat_ttsavedprice').empty();
                        $('.js_cat_ttsavedprice').closest('.saved').hide();
                    }
                    //console.log(arrCat[5])
                    if (arrCat[5] == '1') {
                        $('.js_gift_wrap').addClass('dn');
                    } else {
                        $('.js_gift_wrap').removeClass('dn');
                    }

                    $('body').trigger('refresh_currency');
                    if ($.magnificPopup.instance.isOpen) {
                        $.magnificPopup.close();
                    }

                    //if (bl && !body.hasClass('pside_opened')) {  $('.push_side[data-id="#nt_cart_canvas"]').trigger('click'); }
                }
                $('.nt_js_cart.loading, .js_addtc.loading, .js_frm_cart.loading, .js_add_group.loading, .sticky_atc_js.loading').removeClass('loading');
                $ld.trigger("ld_bar_end");
                if (blUp_items) {
                    $('html, body').animate({
                        scrollTop: $('#shopify-section-cart-template').offset().top - 40
                    }, 400);
                }

                // console.log('更新成功');
                let CurrentCart = arrCat[2];
                $('.cart_items.js_cat_items').html(CurrentCart)
            })
            .catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            });

    } else {
        fetch('/cart?view=js', {
            "credentials": "same-origin",
            "headers": {
                "cache-control": "no-cache"
            }
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                data = data.split('[split_t4nt0]')[1];
                var arrCat = data.split("[split_t4nt]"),
                    OldCartCount = $('.jsccount').first().html(),
                    CurrentCartCount = arrCat[0];

                if (CurrentCartCount != OldCartCount) {
                    $('body').removeClass('t4_cart_count_' + OldCartCount).addClass('t4_cart_count_' + CurrentCartCount);
                    if (parseInt(CurrentCartCount) == 0) {
                        $('.nt_js_cart .js_cart_note,.nt_js_cart .js_cart_footer,.nt_js_cart .js_cart_tool,.js_cat_items,.js_cart_cd').hide();
                        $('.nt_js_cart .empty').show();
                        $('[data-cart-upsell-js]').html('');
                    } else {
                        $('.nt_js_cart .empty').hide();
                        $('.nt_js_cart .js_cart_note,.nt_js_cart .js_cart_footer,.nt_js_cart .js_cart_tool,.js_cat_items,.js_cart_cd').show();
                    }

                    $('.jsccount').html(CurrentCartCount)
                    var aar1 = arrCat[1].split(',]'),
                        this_thres = $('.cart_thres_' + aar1[0]);
                    if (aar1 != 'spt4') {
                        //console.log(arrCat[1])
                        if (this_thres.is(":hidden")) {
                            $('.cart_thres_1,.cart_thres_2,.cart_thres_3').slideUp(200);
                            this_thres.slideDown(250);
                        }
                        if (CurrentCartCount != 0 && $('.cart_thres_3').is(":hidden")) {
                            ck_canvas = true;
                        } else {
                            ck_canvas = false
                        }
                        // UpdateShipBar(arrCat[1],aar1[1],this_thres);
                    }
                    if (blUp_items) { $('.js_cat_items').html(arrCat[2]); }
                    $('.js_cat_dics').html(arrCat[3]);
                    $('.js_cat_ttprice').html(arrCat[4]);
                    var savedMoney = parseInt($(".js_cat_ttprice .saved_price_box").first().attr('data-price'), 10) || 0;
                    $('.mini_cart_footer .saved').attr('data-savedmoney', savedMoney);
                    $('.js_cat_ttsavedprice').closest('.saved').attr('data-savedmoney', savedMoney);
                    if (savedMoney > 0) {
                        $('.js_cat_ttsavedprice').html('<div class="cart_tot_price">-' + geckoShopify.formatMoney(savedMoney) + '</div>');
                        $('.js_cat_ttsavedprice').closest('.saved').show();
                    } else {
                        $('.js_cat_ttsavedprice').empty();
                        $('.js_cat_ttsavedprice').closest('.saved').hide();
                    }
                    if (arrCat[5] == '1') {
                        $('.js_cart_tls_back').trigger('click')
                        $('.js_gift_wrap').addClass('dn');
                    } else {
                        $('.js_gift_wrap').removeClass('dn');
                    }

                    gift.WidgetCartUpdateMobile();
                    $('body').trigger('refresh_currency');
                    // open hidden sidebar cart

                    // console.log('更新成功');
                    let CurrentCart = arrCat[2];
                    $('.mini_cart_items').html(CurrentCart)
                }
                $('.nt_js_cart.loading, .js_addtc.loading, .js_frm_cart.loading, .js_add_group.loading, .sticky_atc_js.loading').removeClass('loading');
                $ld.trigger("ld_bar_end");
            })
            .catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            });
    }
}
gift.WidgetCartUpdateMobile = function () {
    if ($('.js_cart_footer').height() < $(window).height() / 2 || $('#nt_cart_canvas').hasClass('fix_layout_mbt4') || window_w > 767) return;
    $('#nt_cart_canvas').addClass('fix_layout_mbt4');
}

gift.init()
